<template>
  <div class="subject_main" onselectstart="return false;" id="cancelPopover">
    <div class="wrapper">
      <div class="chapter_tree_box">
        <div class="chapter_tree_box_head_none" v-if="false"></div>
        <div class="chapter_tree_box_trees">
          <el-tree
            :data="SectionData"
            :props="SectionProps"
            @node-click="getSectionData"
            node-key="guid"
            :default-expanded-keys="showNode"
            highlight-current
            ref="treeBox"
          >
            <div class="tree_line" slot-scope="{ node, data }">
              <div>{{ node.label }}</div>
            </div>
          </el-tree>
        </div>
        <div class="chapter_tree_box_head_none"></div>
      </div>
      <div class="content flex-col">
        <div class="content_nav">
          <div class="flex-row-v-center content_nav_item">
            <span>状态：</span>
            <div
              :class="{
                content_nav_item_btn: true,
                content_nav_item_btn_active: tab_active == index,
                'flex-center': true,
              }"
              v-for="(item, index) in tab_list_resource"
              :key="index"
              @click="switchTab(item, index)"
            >
              <span>
                {{ item.name }}
                <!-- <div class="redSpot" v-if="index == 4&&rejected_num>0"></div> -->
              </span>
            </div>
          </div>
        </div>
        <div class="flex-1 content_box">
          <div class="content_list">
            <div class="course_box_head">
              <div class="course_search">
                <el-input
                  placeholder="请输入名称"
                  v-model="searchTxt"
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="btnsearch"
                    style="border-radius: 50%"
                  ></el-button>
                </el-input>
              </div>
              <div class="course_creat_sort">
                <div class="creat_course" @click="add_btn()">创建备课包</div>
              </div>
            </div>
            <!-- 备课包 -->
            <div class="content_listBox">
              <div
                class="content_listBox_item clearfix"
                v-for="(item, index) in list_resource"
                :key="index"
              >
                <div class="flex-row">
                  <div class="content_listBox_Img">
                    <img
                      src="../../assets/images/course_2.0/course.png"
                      alt=""
                    />
                  </div>
                  <div class="flex-col">
                    <div class="content_listBox_title">{{ item.name }}</div>
                    <div class="flex-row">
                      <span
                        class="content_listBox_txt"
                        v-if="item.apply_time != 0"
                        >提审时间：{{ item.apply_time | dataFormat }}</span
                      >
                      <!-- <span class="content_listBox_txt" v-else
                        >时间：{{ item.createtime }}</span
                      > -->
                      <span class="content_listBox_txt"
                        >作业：<span style="color: #ff9b36">{{
                          item.m_uuid + item.a_uuid + item.b_uuid
                        }}</span></span
                      >
                      <span class="content_listBox_txt"
                        >资料：<span style="color: #ff9b36">{{
                          item.material_sub_num || 0
                        }}</span></span
                      >
                      <span class="content_listBox_txt"
                        >创建人：{{ item.from }}-{{ item.teacher_name }}</span
                      >
                      <!-- <span class="content_listBox_txt"
                        >热度：<span style="color: #ff3945">{{
                          item.heat
                        }}</span></span
                      > -->
                    </div>
                  </div>
                  <div class="statusBox">
                    <el-tag v-if="item.approval_status == 1" type="success"
                      >审核通过</el-tag
                    >
                    <el-tag v-if="item.approval_status == 20" type="info"
                      >草稿</el-tag
                    >
                    <el-tag v-if="item.approval_status == 30" type="warning"
                      >待审核</el-tag
                    >
                    <el-tag v-if="item.approval_status == 40" type="danger"
                      >未通过</el-tag
                    >
                  </div>
                </div>
                <div class="content_item_btnBox flex-row">
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    v-if="item.approval_status == 20"
                    @click="onSubmit(item)"
                  >
                    <img
                      title="提交审核"
                      src="../../assets/images/course_2.0/submit.png"
                      alt=""
                    />
                    <span>提交审核</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    v-if="item.approval_status == 40"
                    @click="onReject(item.course_id)"
                  >
                    <img
                      title="驳回原因"
                      src="../../assets/images/course_2.0/reject.png"
                      alt=""
                    />
                    <span>驳回原因</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    v-if="
                      item.approval_status == 20 || item.approval_status == 40
                    "
                    @click="onEdit(item, item.id, $event, '编辑')"
                  >
                    <img
                      title="编辑"
                      src="../../assets/images/course_2.0/edit.png"
                      alt=""
                    />
                    <span>编辑</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    v-if="item.approval_status == 30"
                    @click="onRevoke(item)"
                  >
                    <img
                      title="撤销"
                      src="../../assets/images/course_2.0/revoke.png"
                      alt=""
                    />
                    <span>撤销</span>
                  </div>
                  <div
                    class="content_item_btnBox_item flex-row-v-center"
                    v-if="item.approval_status == 20"
                    @click="del_collection(item, index)"
                  >
                    <img
                      title="删除"
                      src="../../assets/images/course_2.0/删除.png"
                      alt=""
                    />
                    <span>删除</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!list_resource.length" class="course_card_empty"></div>
          </div>
          <div style="text-align: right" v-if="total > 10">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="changePage"
              :page-size="10"
              :current-page="pageNum"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisible"
      top='20%'
      width="30%"
    >
      <div>{{reject_reason}}</div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import ifram from "../../components/ifarm/ifarm";
import bus from "../../plugins/Bus";
import preventReClick from "../../config/preventReclick"; //防多次点击，重复提交
import {
  changeData_long,
  getNodeCode,
  getNodeCode_topic,
} from "../../assets/js/common";
import {
  TimestampToTime_weekday,
  TimestampToTime_ss,
} from "../../config/common";
import homeTimetable from "../../components/home/home_timetable.vue";
import previewData from "../../components/common_module/preview_data.vue";

export default {
  components: { homeTimetable, previewData, ifram, draggable, preventReClick },
  data() {
    return {
      searchTxt: "",
      visible: false,
      userInfo: "",
      tab_active: 0, //来源
      approval_status: 100,
      list_resource: [],
      total: 0,
      sort_time: "全部",
      sort_type: "时间最新",
      order: "descending",
      sort: "createtime",
      startTime_sort: "",
      endTime_sort: "",
      pageNum: 1,
      pageSize: 10,

      prew_type: "",
      prew_content: "",
      showNode: [],
      showNode_node: [],
      tab_list_resource: [
        { name: "全部", id: 100 },
        { name: "草稿", id: 20 },
        { name: "待审核", id: 30 },
        { name: "已通过", id: 1 },
        { name: "未通过", id: 40 },
      ],
      SectionData: [],
      SectionProps: {
        children: "children",
        label: "name",
      },
      question_type: [],
      book: [],
      code: [],
      new_tree_code_add: "", //章节编码
      chapter_name: "",
      tree_code: "",
      rejected_num: 0,
      dialogVisible:false,
      reject_reason:"",
    };
  },
  filters: {
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input * 1000);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d}`;
      }
    },
  },
  watch: {},
  provide() {
    return {
      from_classtable: this.from_classtable,
    };
  },
  mounted() {
    let that = this;
    that.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.getSubject(sessionStorage.subject_code);
    //this.get_sourceBag();
  },
  methods: {
    onReject(course_id) {
      let params = {
        course_id,
      };
      this.axios.post("/school/course/rejectInfo", params).then((res) => {
        if (res.data.code == 1) {
          this.reject_reason = res.data.data.data[0].reject_reason;
          this.dialogVisible = true
        }
      });
    },
    del_collection(item, index) {
      let that = this;
      this.$confirm("此操作将删除备课包, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let formData = new FormData();
          formData.append("course_uuid", item.course_uuid);
          this.axios
            .post("/school/Collection_course/delCollection", formData)
            .then((res) => {
              if (res.data.code == 1) {
                that.$message({
                  type: "success",
                  message: "删除成功",
                  duration: 1500,
                  showClose: true,
                });
                this.get_sourceBag();
              } else {
                that.$message({
                  type: "error",
                  message: res.data.msg,
                  duration: 1500,
                  showClose: true,
                });
              }
            });
        })
        .catch(() => {});
    },
    //编辑备课包
    onEdit(row, id, e, query) {
      console.log(row);
      // console.log(this.$refs.edit_course[0] )
      // console.log(e )
      // return
      sessionStorage.removeItem("content_json");
      sessionStorage.removeItem("teaching_text_e");
      sessionStorage.removeItem("course_content_course_name");

      sessionStorage.removeItem("teaching_text_name_e");
      sessionStorage.removeItem("teaching_text_name");
      sessionStorage.removeItem("guidance_text_e");
      sessionStorage.removeItem("guidance_text");
      sessionStorage.removeItem("teaching_text");
      sessionStorage.removeItem("guidance_text_uuid");
      sessionStorage.removeItem("teaching_text");
      sessionStorage.removeItem("course_content");
      sessionStorage.removeItem("course_content_guide_name");
      sessionStorage.removeItem("course_content_guide_json");
      sessionStorage.removeItem("course_content_type");
      sessionStorage.course_add_type = "edit";
      sessionStorage.course_new_courseId = row.course_uuid;
      let obj = {
        book_code: this.book_code_add,
        chapter_code: this.new_tree_code_add,
        chapter_name: this.chapter_name,
      };
      sessionStorage.course_new_obj = JSON.stringify(obj);
      this.$router.push({
        path: "/course/sign_course_new?from=resource",
        query: { name: query, from: "myResource" },
      });
    },
    //撤销审核
    onRevoke(item) {
      this.$confirm("此操作将撤销审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            course_id: item.course_id,
            approval_status: 20,
          };
          this.axios
            .post("/school/course/changeApprovalStatus", params)
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  type: "success",
                  message: "撤销成功",
                  duration: 1500,
                  showClose: true,
                });
                this.get_sourceBag();
              }
            });
        })
        .catch(() => {});
    },
    //提交审核
    onSubmit(item) {
      let params = {
        course_id: item.course_id,
        approval_status: 30,
      };
      this.axios
        .post("/school/course/changeApprovalStatus", params)
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: "提交成功",
              duration: 1500,
              showClose: true,
            });
            this.get_sourceBag();
          }
        });
    },
    add_btn() {
      sessionStorage.removeItem("content_json");
      // this.visible = true;
      this.po_up_title = "新增备课包";
      if (this.po_up_title == "新增备课包") {
        sessionStorage.removeItem("teaching_text_e");
        sessionStorage.removeItem("course_content_course_name");

        sessionStorage.removeItem("teaching_text_name");
        sessionStorage.removeItem("teaching_text_name_e");
        sessionStorage.removeItem("guidance_text_e");
        sessionStorage.removeItem("guidance_text");
        sessionStorage.removeItem("guidance_text_uuid");
        sessionStorage.removeItem("teaching_text_uuid");
        sessionStorage.removeItem("teaching_text");
        sessionStorage.removeItem("course_content");
        sessionStorage.removeItem("course_content_guide_name");
        sessionStorage.removeItem("course_content_guide_json");
        sessionStorage.removeItem("course_content_type");
        let str = this.new_tree_code_add;
        let obj = {
          book_code: this.book_code_add,
          chapter_code: str,
          courseName: "新增备课包",
          chapter_name: this.chapter_name,
        };
        sessionStorage.course_add_type = "new";
        sessionStorage.course_name_new = "新增备课包";
        sessionStorage.course_new_obj = JSON.stringify(obj);
        this.$router.push({
          path: "/course/sign_course_new",
          query: {
            name: "新增备课包",
            label: this.homework_label_id,
            from: "myResource",
          },
        });
      }
    },
    //点击切换来源
    switchTab(item, index) {
      this.pageNum = 1;
      this.tab_active = index;
      this.approval_status = item.id;
      this.get_sourceBag();
    },
    //模糊查询
    btnsearch() {
      this.pageNum = 1;
      this.get_sourceBag();
    },

    //分页 换页
    changePage(pageNum) {
      this.pageNum = pageNum;
      this.get_sourceBag();
    },

    //请求资源全家桶
    get_sourceBag() {
      let formData = new FormData();
      let url = "/school/collection_course/collectionList";
      // formData.append("order", this.order);
      // formData.append("sort", this.sort);
      formData.append("name", this.searchTxt);
      // formData.append("start_time", this.startTime_sort);
      // formData.append("end_time", this.endTime_sort);
      formData.append("subject_code", sessionStorage.subject_code);
      formData.append("current_page", this.pageNum);
      formData.append("page_size", this.pageSize);
      formData.append("chapter_code", this.tree_code);
      formData.append("approval_status", this.approval_status);
      this.axios.post(url, formData).then((res) => {
        if (res.data.code == 1) {
          this.total = res.data.data.count;
          this.list_resource = res.data.data.data;
          this.rejected_num = res.data.data.rejected_num;
          this.processing(this.list_resource);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
            duration: 1500,
            showClose: true,
          });
        }
      });
    },
    //处理数据
    processing(list) {
      for (var i = 0; i < list.length; i++) {
        try {
          list[i].b_uuid = JSON.parse(list[i].content).b.uuid.length;
          list[i].b_f = JSON.parse(list[i].content).b.f.length;
          list[i].m_uuid = JSON.parse(list[i].content).m.uuid.length;
          list[i].m_f = JSON.parse(list[i].content).m.f.length;
          list[i].a_f = JSON.parse(list[i].content).a.f.length;
          list[i].a_uuid = JSON.parse(list[i].content).a.uuid.length;
          list[i].createtime = list[i].createtime.split(" ")[0];
        } catch (error) {
          list[i].b_uuid = 0;
          list[i].b_f = 0;
          list[i].a_uuid = 0;
          list[i].a_f = 0;
          list[i].m_uuid = 0;
          list[i].createtime = list[i].createtime.split(" ")[0];
        }
      }
    },

    //删除教案
    del_teaching(item) {
      if (this.type_second == "teaching") {
        let that = this;
        this.$confirm("此操作将删除教案, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let formData = new FormData();
            formData.append("teaching_uuid", item.teaching_uuid);
            this.axios
              .post("/school/Collection_Teaching/delCollection", formData)
              .then((res) => {
                if (res.data.code == 1) {
                  that.$message({
                    type: "success",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  that.$message({
                    type: "error",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      } else if (this.type_second == "homework") {
        let that = this;
        this.$confirm("此操作将删除作业, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let formData = new FormData();
            formData.append("homework_uuid", item.homework_uuid);
            this.axios
              .post("/school/Collection_homework/delCollection", formData)
              .then((res) => {
                if (res.data.code == 1) {
                  that.$message({
                    type: "success",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  that.$message({
                    type: "error",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      } else if (this.type_second == "guidance") {
        let that = this;
        this.$confirm("此操作将删除导学案, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let formData = new FormData();
            formData.append("guidance_uuid", item.guidance_uuid);
            this.axios
              .post("/school/Collection_Guidance/delCollection", formData)
              .then((res) => {
                if (res.data.code == 1) {
                  that.$message({
                    type: "success",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  that.$message({
                    type: "error",
                    message: res.data.msg,
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      } else {
        this.$confirm("此操作将删除资料，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var formData = new FormData();
            formData.append("material_uuid", item.material_uuid);
            this.axios
              .post("/school/Collection_Material/delCollection", formData)
              .then((res) => {
                // console.log(res);
                if (res.data.code == 1) {
                  // this.Iscollect = true;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                    duration: 500,
                    showClose: true,
                  });
                  this.get_sourceBag();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                    duration: 500,
                    showClose: true,
                  });
                }
              });
          })
          .catch(() => {});
      }
    },

    //获取教材 章节
    getSubject(code) {
      let that = this;
      let formData = new FormData();
      formData.append("subject_code", code);
      this.axios.post("/teacher/subject/gettextbook", formData).then((res) => {
        if (res.data.data != "") {
          this.book = res.data.data;
          for (var i = 0; i < this.book.length; i++) {
            this.code.push(this.book[i].code);
            if (
              this.book[i].id ==
              JSON.parse(sessionStorage.userInfo).textbook_code
            ) {
              this.book_edit = res.data.data;
              this.changeText =
                res.data.data[i].name + " - " + res.data.data[i].publish;
              this.changeText_edit =
                res.data.data[i].name + " - " + res.data.data[i].publish;
              this.book_code_add = res.data.data[i].code;
              this.chapter_add_code = JSON.parse(
                this.book[i].chapter_json
              )[0].c;
              this.chapter_name = JSON.parse(this.book[i].chapter_json)[0].name;

              if (res.data.data[i].chapter_json != "") {
                let SectionData = JSON.parse(res.data.data[i].chapter_json);
                this.textbook_code = this.book[i].code;

                this.tree_code = "";
                this.SectionData = SectionData;

                for (let i in this.SectionData) {
                  this.showNode.push(this.SectionData[i].guid);
                }
                sessionStorage.SectionData = JSON.stringify(SectionData);
              } else {
                this.SectionData = [];
                this.SectionData_edit = [];
              }
              break;
            } else {
              this.book_edit = res.data.data;
              this.changeText =
                res.data.data[0].name + " - " + res.data.data[0].publish;
              this.changeText_edit =
                res.data.data[0].name + " - " + res.data.data[0].publish;
              this.book_code_add = res.data.data[0].code;

              if (res.data.data[0].chapter_json.length > 2) {
                this.chapter_add_code = JSON.parse(
                  this.book[0].chapter_json
                )[0].c;
                this.chapter_name = JSON.parse(
                  this.book[0].chapter_json
                )[0].name;
                let SectionData = JSON.parse(res.data.data[0].chapter_json);
                this.textbook_code = this.book[0].code;
                let chapter_code = "";
                for (var j in SectionData) {
                  chapter_code +=
                    j == 0 ? SectionData[j].c : "," + SectionData[j].c;
                }
                this.tree_code = "";
                this.SectionData = SectionData;
              } else {
                this.SectionData = [];
                this.SectionData_edit = [];
              }
            }
          }

          if (!this.tree_code) {
            this.getSectionData(this.SectionData[0]);
            this.$nextTick(() => {
              that.$refs.treeBox.setCurrentKey(this.SectionData[0].guid);
            });
          }
        } else {
          this.book = [];
          this.book_edit = [];
        }
      });
    },
    //根据树形筛选
    getSectionData: function (data) {
      console.log(data);
      this.getSectionData_treedata = data;
      this.new_tree_code_add = data.c;
      this.chapter_name = data.name;
      let str = getNodeCode(data, []);
      this.is_CurrentKey = data.guid;
      this.getSectionData_text = data.name;
      this.SectionData_edit = this.SectionData;
      this.chapter_add_code = this.is_CurrentKey;
      this.tree_code = str;

      let str_node = getNodeCode_topic(data, []).join(",");
      this.str_node = str_node;
      this.pageNum = 1;
      this.get_sourceBag();
    },
    //递归获取所有子章节编码
    get_child_chapter_code(all_chapter, current_code) {
      let chapter_code_temp = "",
        temp;
      for (var i in all_chapter) {
        if (all_chapter[i].p_c == current_code) {
          chapter_code_temp += "," + all_chapter[i].c;
          temp = this.get_child_chapter_code(all_chapter, all_chapter[i].c);
          if (temp != "") {
            chapter_code_temp += temp;
          }
        }
      }
      return chapter_code_temp;
    },
  },
  created() {},

  beforeDestroy() {
    bus.$off("sendSubject_code");
    this.$store.state.data_save_course = this.$data;
  },
};
</script>

<style >
.assign_homework_choose_class_dia {
  width: 660px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
}
.assign_homework_choose_class_dia .el-dialog__footer {
  text-align: center !important;
}
.homework_edit_choose_topic .el-dialog__footer {
  text-align: center !important;
}
.add_course_info_head_course_name_add_name .el-input__inner {
  border-color: transparent !important;
  background: #f3f3f3;
  border-radius: 20px 0px 20px 2px;
  text-align: center;
  font-size: 16px !important;
  height: 40px !important;
}
.add_course_info_head_course_name_add_name.el-checkbox__label {
  font-size: 12px !important;
}
.area_popper .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper {
  border-color: #ff9b36;
  width: 300px;
  height: 400px;
  padding-right: 0;
  overflow: auto;
  font-size: 16px;
  line-height: 16px;
}
.homework_edit_choose_topic {
  width: calc(100vw - 720px);
  border-radius: 12px;
  /* height: 90vh; */
  overflow: hidden;
  margin-top: 5vh !important;
}
.homework_edit_choose_topic .el-dialog__body {
  background: #f2f2f2;
}
.add_course_info_head_course_name_add_name .el-input__inner {
  border-color: transparent !important;
  background: #f3f3f3;
  border-radius: 20px 0px 20px 2px;
  text-align: center;
  font-size: 16 !important;
  height: 40px !important;
}
.add_course_info_head_course_name_add_name.el-checkbox__label {
  font-size: 12px !important;
}
.dialogVisible_add_material {
  border-radius: 20px;
}
.dialogVisible_add_material .el-dialog__footer {
  text-align: center;
}
.dialogVisible_add_material .el-dialog__footer .el-button {
  margin: 0 50px;
}
.labe_wd .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.labe_wd .el-input__icon {
  /* height: 36px !important; */
  line-height: 38px !important;
}

.send_course_dia {
  border-radius: 20px;
}
.course_search .el-input-group__append {
  border-radius: 0 20px 20px 0;
}
.course_search .el-input__inner {
  border-radius: 20px 0 0 20px;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 16px !important;
}
.course_search .el-input {
  height: 40px;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}
.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}
.color_active {
  color: #ff9b36 !important;
}
</style>



<style scoped>
.add_course_info_head_course_name_add_name {
  align-items: center;
}
.add_course_info_head_course_name_add_name > div:nth-of-type(1) {
  width: 120px;
}
.subject_main {
  overflow: hidden;
}
.wrapper {
  margin: 14px auto;
  display: flex;
  justify-content: space-between;
  /* background: white; */
  height: calc(100vh - 152px);
  overflow: hidden;
  width: 75vw;
}
.chapter_tree_box {
  width: 432px;
  /* height:100%; */
  /* overflow: auto; */
  padding: 10px;
  padding-bottom: 0px;
  /* background: #ffffff; */
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding-top: 0;
  box-sizing: border-box;
}
.chapter_tree_box_head_none {
  height: 1px;
}
.chapter_tree_box_trees {
  flex: 1;
  overflow: auto;
  padding: 10px 0;
  background: #ffffff;
  border-radius: 12px;
}
.chapter_tree_box_head {
  /* height: 60px; */
  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
  border-radius: 12px;
  margin-bottom: 16px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  height: 30px;
  padding: 15px 0;
  text-align: center;
}
.chapter_tree_box_head > div {
  cursor: pointer;
}
.tree_line {
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
}
.tree_line > div:nth-of-type(1) {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content {
  flex:1;
  /* background: #ffffff; */
  border-radius: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}
.content_head {
  margin-bottom: 16px;
}
.content_head_nav {
  width: 85%;
  padding: 10px 26px 10px 26px;
  background: #ffffff;
  border-radius: 12px;
}
.content_head_btn {
  width: 52px;
  height: 52px;
  background: #ffffff;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9b36;
  cursor: pointer;
}
.content_head_nav_item span {
  cursor: pointer;
  font-size: 16px;
}
.course_type_line {
  width: 36px;
  height: 5px;
  background: #54a9fd;
  border-radius: 3px;
  margin: 3px auto;
  opacity: 1;
}
.course_type_line_hide {
  width: 36px;
  height: 5px;
  background: #54a9fd;
  border-radius: 3px;
  margin: 3px auto;
  opacity: 0;
}
.active_color {
  color: #69b4ff;
}
.content_nav {
  padding: 15px;
  padding-bottom: 0;
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 14px;
}
.content_nav_item {
  margin-bottom: 15px;
}
.content_nav_item_btn {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
  margin-right: 25px;
  padding: 3px 10px;
  min-width: 62px;
  position: relative;
}
.content_nav_item_btn_active {
  border: 1px solid #69b4ff;
  border-radius: 13px;
  color: #6ab4f8;
}
.content_box {
  background: #ffffff;
  border-radius: 12px;
}
.content_list {
  height: calc(100% - 50px);
}
.course_box_head {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-between;
  margin: 14px 16px 17px 18px;
  height: 40px;
}
.course_search {
  height: 40px;
}
.course_creat_sort {
  display: flex;
  justify-items: center;
}
.content_listBox_item {
  border: 2px solid #54a9fd;
  padding: 15px 10px;
  border-radius: 6px 20px 20px 6px;
  margin-bottom: 14px;
  position: relative;
}
.content_listBox {
  padding: 5px 18px;
}
.content_item_icon {
}
.content_item_icon img {
  width: 63px;
  height: 65px;
}
.content_item_info {
  margin-left: 13px;
}
.content_item_info p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 0;
}
.mr23 {
  margin-right: 23px;
}
.content_item_btnBox {
  margin-top: 10px;
  float: right;
}
.content_item_btnBox_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
  margin-right: 35px;
}
.content_item_btnBox_item img {
  width: 17px;
  height: 17px;
  margin-right: 7px;
}

.color999 {
  color: #999999;
}
.dataBag {
  width: 70px;
  height: 160px;
  background: #ff9b36;
  border-radius: 0px 20px 20px 0px;
  position: fixed;
  top: 65%;
  margin-left: 810px;
  cursor: pointer;
}
.dataBag img {
  width: 34px;
  height: 35px;
  margin-top: 39px;
}
.dataBag span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.testQuestions {
  position: fixed;
  top: 30%;
  margin-left: 810px;
  cursor: pointer;
}
.dataBag2 {
  width: 70px;
  height: 160px;
  background: #ff9b36;
  border-radius: 0px 20px 20px 0px;
  position: fixed;
  top: 65%;
  margin-left: 1205px;
  cursor: pointer;
}
.dataBag2 img {
  width: 34px;
  height: 35px;
  margin-top: 39px;
}
.dataBag2 span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.testQuestions2 {
  position: fixed;
  top: 30%;
  margin-left: 1205px;
  cursor: pointer;
}
.testQuestions2 img {
  width: 34px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
}
.testQuestions2 span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.testQuestionsBox {
  width: 70px;
  height: 160px;
  background: #69b4ff;
  border-radius: 0px 20px 20px 0px;
}
.testQuestions img {
  width: 34px;
  height: 35px;
  margin-top: 20px;
  margin-bottom: 5px;
}
.testQuestions span {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.testBtn {
  width: 70px;
  height: 23px;
  background: #ffffff;
  border: 1px solid #69b4ff;
  box-shadow: 0px 1px 8px 0px rgba(63, 145, 227, 0.35);
  border-radius: 0px 12px 0px 0px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #69b4ff;
  cursor: pointer;
}
.numClass {
  padding: 1px 10px;
  margin-top: 8px;
  line-height: 16px;
  background-color: #ff4848;
  border-radius: 8px;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  color: #fff;
  font-size: 12px;
}
.content_item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  height: 40px;
  line-height: 40px;
}
.content_item_title {
  width: 110px;
  text-align: left;
  margin-right: 10px;
}
.assign_type {
  height: 32px;
  background: #f3f3f3;
  border-radius: 8px;
  line-height: 32px;
  padding: 0 20px;
  color: #666666;
  cursor: pointer;
  margin: 0 9px 0 24px;
}
.icon_question {
  color: #cccccc;
  cursor: pointer;
  font-size: 16px;
}
.assign_type:active {
  background: #69b4ff !important;
  color: #ffffff !important;
}
.assign_type:hover {
  background: #69b4ff !important;
  color: #ffffff !important;
}
.assign_type_active {
  background: #69b4ff !important;
  color: #ffffff !important;
}
.homework_list {
  width: 360px;
  background: #f4faff;
  border-radius: 20px 2px 20px 2px;
  margin-left: 120px;
  padding: 0 24px;
  overflow: auto;
}
.homework_list_item {
  display: flex;
  height: 18px;
  line-height: 18px;
  align-items: center;
  margin: 24px 0;
}
.homework_list_item img {
  display: block;
  width: 22px;
  height: 18px;
  margin-right: 12px;
}
.homework_list_item_close {
  display: block;
  margin-left: auto;
  cursor: pointer;
  font-size: 16px;
  color: #666666;
}
.content_item_btn {
  height: 32px;
  background: #ff9b36;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  padding: 0 20px;
  cursor: pointer;
}
.class_list {
  margin-left: 120px;
}
.homework_list_item_group_icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  background: #ff9b36;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  margin-right: 12px;
}
.homework_list_item_class_icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  background: #69b4ff;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  margin-right: 12px;
}
.correct_set {
  margin-left: 48px;
  width: 160px !important;
}
.correct_set_time {
  margin-left: 68px;
  width: 80px !important;
}
.content_item_margin {
  margin: 20px 0 !important ;
}
.class_list_choose {
  background: #f8f8f8;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  padding: 16px 20px;
}
.choose_group_title {
  margin-top: 16px;
}
.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.topic_list_item {
  padding: 16px;
  border: 4px solid #69b4ff;
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 6px 20px 20px 6px;
  /* height: 264px;
		overflow: hidden; */
  margin-bottom: 20px;
  cursor: pointer;
  padding-bottom: 10px;
}
.topic_txt span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  display: inline-block;
  margin-right: 10px;
}
.topic_Btn img {
  width: 15px;
  height: 16px;
  margin-right: 9px;
}
.topic_btnItem {
  padding: 8px 14px;
  background: #69b4ff;
  border-radius: 8px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-left: 20px;
}
.topic_answer_analyzing {
  border: 1px solid #69b4ff;
  border-radius: 8px;
  padding: 13px;
}

.tip {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 500px;
  padding: 13px;
  /* overflow-x:hidden ; */
  /* overflow-y:scroll ; */
}
.tip2 {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 60%;
  margin-left: 895px;
  padding: 13px;
  /* overflow-x:hidden ; */
  /* overflow-y:scroll ; */
}
.trangle {
  width: 0px;
  height: 0px;
  border: 14px solid #000;
  border-top-color: transparent;
  border-bottom-color: transparent;
  border-left-color: #69b4ff;
  border-right-color: transparent;
  position: absolute;
  right: -28px;
  top: 80px;
}
.tipHead span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.tipItem {
  margin-bottom: 17px;
}
.tipItemList {
  margin-bottom: 10px;
}
.tipItemName {
  width: 140px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  cursor: pointer;
}
.tipBtn {
  padding: 12px 9px;
  background: #ff9b36;
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
}
.tipTiku {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 40%;
  margin-left: 500px;
  padding: 13px;
}
.tipTiku2 {
  width: 296px;
  height: 300px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #69b4ff;
  border-radius: 20px;
  position: relative;
  font-size: 12px;
  position: fixed;
  top: 40%;
  margin-left: 895px;
  padding: 13px;
}
.tikuListItem {
  margin-bottom: 16px;
}
.tikuTypeName {
  width: 100px;
}
.testList {
  width: 70px;
  background: #f9fcff;
  border-radius: 0px 20px 20px 20px;
  padding: 5px 0px;
  visibility: hidden;
}
.isShowTestList {
  visibility: visible;
}
.testListItem {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin: 3px 0;
  cursor: pointer;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.testListItemActive {
  color: #69b4ff;
}
.previewListBox {
  background: #ffffff;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0px 15px;
}
.previewListBoxHead {
  padding: 15px 0px;
}
.backIcon img {
  width: 24px;
  height: 20px;
  cursor: pointer;
}
.previewBtn {
  padding: 9px 11px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  background: #69b4ff;
  border-radius: 8px;
  cursor: pointer;
}
.course_card_empty {
  background: url(../../assets/images/course_2.0/老师.png);
  width: 100%;
  height: 80%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200px auto;
}
.creat_course {
  /* width: 78px; */
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}
.add_material_contnet {
  padding: 0 20px;
}
.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}
.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}
.add_material_content_btn {
  margin: 10px 0;
}
.uploader-drop {
  border: 0 !important;
  background-color: transparent;
  padding: 0;
  margin: 0 0 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.edit_material_item_type_name {
  margin-bottom: 20px;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
}
.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 30px 0;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}
.add_course_info_content_box_content_item_img_homework {
  display: block;
  width: 43px;
  height: 35px;
  margin: 32px auto;
}
.add_course_info_content_box_content_item_img_ppt {
  display: block;
  width: 35px;
  height: 42px;
  margin: 28px auto;
}
.add_course_info_content_box_content_item_img_teaching {
  display: block;
  width: 44px;
  height: 47px;
  margin: 26px auto;
}

.add_course_info_content_box_content_item_txt {
  width: 120px;
  height: 35px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
.content_listBox_Img img {
  width: 58px;
  height: 60px;
  margin-right: 16px;
}
.content_listBox_title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.content_listBox_txt {
  margin-right: 8px;
  font-size: 12px !important;
}
.marin_bottom {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  line-height: 32px;
}
.choosed_time {
  height: 32px;
  border: 1px solid #ff9b36;
  box-shadow: 0px 0px 4px 0px #fe8b17;
  border-radius: 8px;
  line-height: 32px;
  text-align: center;
  /* margin-top: 10px; */
  padding-right: 10px;
  color: #ff9b36;
}
.marin_bottom > div:nth-of-type(2) {
  height: 32px;
  background: #69b4ff;
  border-radius: 8px;
  padding: 0 18px;
  line-height: 32px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
.confirm_cancel {
  display: flex;
  justify-content: space-between;
}
.labe_wd {
  height: 180px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 14px;
  /* box-sizing: border-box; */
  margin-bottom: 20px;
  position: relative;
  border: 1px solid #dfdfdf;
}
.choose_course_time {
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  padding: 0 14px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  color: #ffffff;
}
.statusBox {
  margin-left: 15px;
  position: absolute;
  right: 20px;
  top: 10px;
}
.topic_content_html {
  overflow-x: auto !important;
}
.redSpot {
  position: absolute;
  background: red;
  top: 0px;
  right: 0px;
  font-size: 10px !important;
  width: 10px;
  height: 10px;
  border-radius: 100%;
}
</style>